document.addEventListener("DOMContentLoaded",function(){

const items=document.querySelectorAll(".gallery-item");

if(!items.length) return;

const lightbox=document.createElement("div");

lightbox.className="gallery-lightbox";

lightbox.innerHTML=`
<div class="gallery-overlay"></div>

<div class="gallery-wrapper">

<button class="gallery-close">&times;</button>

<div class="gallery-content"></div>

</div>
`;

document.body.appendChild(lightbox);

const content=lightbox.querySelector(".gallery-content");

items.forEach(item=>{

item.addEventListener("click",()=>{

content.innerHTML="";

const img=item.querySelector("img");

const video=item.querySelector("video");

if(img){

const clone=img.cloneNode(true);

content.appendChild(clone);

}

if(video){

const clone=video.cloneNode(true);

clone.controls=true;
clone.autoplay=true;
clone.muted=false;

content.appendChild(clone);

}

lightbox.classList.add("active");

document.body.style.overflow="hidden";

});

});

function closePopup(){

lightbox.classList.remove("active");

content.innerHTML="";

document.body.style.overflow="";

}

lightbox.querySelector(".gallery-close").onclick=closePopup;

lightbox.querySelector(".gallery-overlay").onclick=closePopup;

document.addEventListener("keydown",(e)=>{

if(e.key==="Escape"){

closePopup();

}

});

});